(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                var Auth = $injector.get('Auth');
                if (Principal.isAuthenticated()) {
                    Auth.authorize(true);
                } else {
                    Auth.logout();
                    var $state = $injector.get('$state');
                    $state.go('login');
                }
            }
            return $q.reject(response);
        }
    }
})();
